module.exports = __webpack_public_path__ + "img/oneOrange.572f5382.jpg";